import { Tooltip as MuiTooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { MetricTooltipProps } from './metric-tooltip.types';

export const MetricTooltip = ({ children, title, placement = 'top' }: MetricTooltipProps) => {
  return (
    <MuiTooltip
      arrow
      title={title}
      placement={placement}
      componentsProps={{
        tooltip: {
          sx: (theme) => ({
            typography: 'body2',
            backgroundColor: alpha(theme.palette.common.black, 0.8),
            padding: theme.spacing(2),
            borderRadius: theme.spacing(1),
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)',
          }),
        },
        arrow: { sx: (theme) => ({ color: alpha(theme.palette.common.black, 0.8) }) },
      }}
    >
      {children}
    </MuiTooltip>
  );
};
